import { pipe } from 'lodash/fp';

import { isVariantOf, ComponentsVariants } from '@/components.variants';
import resolveColorName from '../resolveColorName';
import resolveReference from '../resolveReference';
import resolveRTC from '../resolveRTC';
import resolveString from '../resolveString';
import resolveTabContent from '../resolveTabContent';
import resolveTheme from '../resolveTheme';

export const isTabbedDocumentPicker = isVariantOf(ComponentsVariants.TABBED_DOCUMENT_PICKER, true);

export const createCarouselVariant = (tabContent: TabContentType[]) => {
  return tabContent.map((content) => ({
    ...content,
    tabDetailContent: {
      ...content.tabDetailContent,
      detailContent: [
        {
          variant: ComponentsVariants.PORTAL_CAROUSEL,
          cards: (content.tabDetailContent?.detailContent || []).filter(
            (detail) => detail.variant === ComponentsVariants.CARD,
          ),
        },
        ...(content.tabDetailContent?.detailContent || []).filter(
          (detail) => detail.variant !== ComponentsVariants.CARD,
        ),
      ],
    },
  }));
};

export default (ravVal: any, page: any, pageModels: any, props: any, resolveContentBlocks: any) => {
  const {
    tabbedDocument: tabbedRef,
    // containerBackgroundColor,
    tabColor,
    // containerTopSpacing,
    template,
    // hasTextShadow,
    textColor,
    // containerBottomSpacing,
  } = props;

  const contentListDoc = resolveReference<any>({ rawVal: tabbedRef, page }) || {};
  const { tabGroupTitle, tabGroupDescription, tabContent } = contentListDoc || {};

  const templateMap: any = {
    vertical: 'thumbnail',
    horizontal: 'bottom',
  };

  return {
    variant: ComponentsVariants.TABBED_LIST,
    content: {
      tabGroupTitle,
      tabGroupDescription: resolveRTC({ rawVal: tabGroupDescription }),
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      tabContent: pipe(
        resolveTabContent(resolveContentBlocks),
        createCarouselVariant,
      )({
        rawVal: tabContent,
        page,
        pageModels,
      }),
    },
    tabColor: resolveColorName({ rawVal: tabColor }),
    theme: resolveTheme('text-color')({ rawVal: textColor }),
    template: templateMap[resolveString({ rawVal: template }) || 'vertical'],
  };
};
